import React from 'react';
import sanitizeHtml from 'sanitize-html';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { COLOR } from '@src/styles/color';
import Tooltip from '@src/components/Tooltip';
import Typography from '@src/new-components/Typography';
import { StyledListTagsFilter } from '@src/containers/VoiceLibrary/Toolbar/index.style';
import { StyledAdvancedFilter } from './index.styled';
import FilterTags from './FilterTags';

const AdvancedFilterSection = ({
  advancedFilterOptions,
  dataFilterDraft,
  handleSelectFilter,
  t,
  onOpenInfoRetentionDays,
}) => (
  <StyledAdvancedFilter>
    {Object.keys(advancedFilterOptions)
      .filter((key) => advancedFilterOptions[key]?.isShow)
      .map((key) => (
        <div
          key={key}
          style={{
            marginBottom: '16px',
            gap: '8px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Typography variant="body-14-medium" color={COLOR.darkGray}>
              {t(key)}
            </Typography>
            {key === 'retentionDays' && (
              <Tooltip
                placement="top"
                arrow
                title={
                  <div
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHtml(t('tooltipRetentionDays')),
                    }}
                  />
                }
              >
                <InfoRoundedIcon
                  onClick={onOpenInfoRetentionDays}
                  sx={{ fontSize: '16px', color: COLOR.indigoIcon }}
                />
              </Tooltip>
            )}
          </div>
          <StyledListTagsFilter>
            <FilterTags
              keyName={key}
              options={advancedFilterOptions[key]?.options}
              dataFilterDraft={dataFilterDraft}
              handleSelectFilter={handleSelectFilter}
            />
          </StyledListTagsFilter>
        </div>
      ))}
  </StyledAdvancedFilter>
);
export default AdvancedFilterSection;
